<template>
<div class="item-base" >
  <el-carousel class="swiper" height="50.9vh">
    <el-carousel-item v-for="(item,index) in UiBanner.photoList" :key="index" class="swiper-item">
      <el-image :src="'http://'+item.address" class="swiper-image"></el-image>
    </el-carousel-item>
  </el-carousel>
</div>
</template>

<script>
export default {
  name: "ProductBanner",
  props:{
    UiBanner:{

    }
  },
}
</script>

<style lang="less" scoped>
.item-base {
  width: 100%;
  height: 50.9vh;
  margin: 0 20px;
  .swiper-image{
    width: 100%;
    height: 100%;
  }
}
</style>